import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  state: {
    isLogined:false,
    userInfo: {},
    language: 'zh-CN'  // 默认语言
  },
  getters: {
  },
  mutations: {
    changeUserInfo(state, value){
      state.userInfo = {
        ...state.userInfo,
        ...value
      }
    },
    clearUserInfo(state,value){
      state.userInfo = {}
    },
    changeLoginStatus(state,value){
      state.isLogined = value
    },
    getUserInfo(){
      return state.userInfo
    },
    setLanguage(state, lang) {
      state.language = lang
    }
  },
  actions: {
    changeLanguage({ commit }, lang) {
      commit('setLanguage', lang)
    }
  },
  modules: {
  },
  plugins: [createPersistedState({
    paths:['isLogined','userInfo'] //控制是否持久化
  })],
})
